const TZ_TO_CURRENCY = [["Pacific/Auckland", "nzd"], ["Pacific/Chatham", "nzd"], ["Australia/", "aud"], ["America/Toronto", "cad"], ["America/Vancouver", "cad"], ["America/Edmonton", "cad"], ["America/Winnipeg", "cad"], ["America/Halifax", "cad"], ["America/St_Johns", "cad"], ["America/Regina", "cad"], ["Europe/London", "gbp"], ["Europe/Belfast", "gbp"], ["America/", "usd"]];

export function guessCurrency() {
  const saved = localStorage.getItem("changeos_currency");
  if (saved) return saved;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const hit = TZ_TO_CURRENCY.find(([p]) => tz.startsWith(p));
  return hit ? hit[1] : "gbp";
}

export function saveCurrency(c) {
  localStorage.setItem("changeos_currency", c);
}

export function money(amount, currency, symbols) {
  return `${(symbols || {})[currency] || currency.toUpperCase() + " "}${Number(amount).toLocaleString()}`;
}
